import { render, staticRenderFns } from "./alarmDetailsDlg.vue?vue&type=template&id=1c60ce6c&"
import script from "./alarmDetailsDlg.vue?vue&type=script&lang=js&"
export * from "./alarmDetailsDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "alarmDetailsDlg.vue"
export default component.exports